import _ from "lodash";
import { toast } from "react-toastify";

import { clearNumber } from "../../functions";

const defaultUserProps = {name: '', cellphone: '', active: true}

export class ConectaProController {
  usersRefetchTimeout = null

  constructor(props) {
    this.newUserProps = defaultUserProps

    this.conectaProModel = props.models.conectaPro


    _.bindAll(this, ['setNewUserProps', 'saveNewUser'])
  }

  validateNewUser (){
    const invalidFields = []

    if(!this.newUserProps.name.trim()) invalidFields.push("O campo Nome do usuário é obrigatório para adicionar um novo usuário")
    if(!this.newUserProps.cellphone) invalidFields.push("O campo Celular é obrigatório para adicionar um novo usuário")
    if(this.newUserProps.cellphone && clearNumber(this.newUserProps.cellphone).length < 11) invalidFields.push("O campo Celular deve conter um número válido para adicionar um novo usuário")

    invalidFields.forEach((error, i) => {
      setTimeout(() => {
        toast.error(error, { theme: "colored" });
      }, 200 * i);
    });

    return !invalidFields.length;
  };

  setNewUserProps(props) {
    this.newUserProps = {...this.newUserProps, ...props}
  }

  saveNewUser(e, cb) {
    if(e) e.preventDefault()

    if(!this.validateNewUser()) return

    this.conectaProModel.createNewUser(this.newUserProps).then()
    this.newUserProps = defaultUserProps

    if(cb) cb()
  }

  getUsers() {
    if(this.usersRefetchTimeout) clearTimeout(this.usersRefetchTimeout)
    this.conectaProModel.fetchUsers().then(()=>{
      this.usersRefetchTimeout = setTimeout(this.getUsers.bind(this), 500)
    })
  }

  refreshSecurityCode(userId) {
    this.conectaProModel.refreshSecurityCode(userId).then()
  }

  setUserStatus(userId, status) {
    this.conectaProModel.updateUser(userId, { active: status }).then()
  }

  removeUser(userId) {
    this.conectaProModel.deleteUser(userId).then()
  }

}
